import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, pipe, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PimaProject } from '../model/pima-project';
import { HttpCommonService } from './http-common.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  private projectUrl = environment.api + '/project';

  constructor(
    private http: HttpClient,
    private httpCommonService: HttpCommonService,
    private tokenService: TokenService
  ) { }

  getProjectById(id: number): Observable<PimaProject> {
    const url = `${this.projectUrl}/get?id=${id}`;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.tokenService.getToken()}` }),
      withCredentials: true
    };
    return this.http.get<PimaProject>(url, httpOptions).pipe
      (
        tap(pi => console.log(`fetched project id=${id}`, pi)),
        catchError(this.httpCommonService.basicErrorHandler)
      );
  }

}
